export default __webpack_public_path__ + "static/media/arrowright.51a39359.gif";